import "chart.js/auto";
import { Bar } from "react-chartjs-2";

function BarChart({data, checkedItems, total}: any) {
    const barChartData = checkedItems.length ? data.filter((entry: any, index: number) => {
        return entry.type === checkedItems[index].type && checkedItems[index].checked;
    }) : [];

    const itemColors = checkedItems.map((checkedItem: any) => checkedItem.color);
    const bgColors = itemColors.filter((color: string|null) => color !== null);

    const values = barChartData.map((entry: any) => entry.total);
    const maxValue = Math.max(...values);
    const bgValues = values.map(() => maxValue);
    const labels = barChartData.map((entry: any) => entry.name);

    const chartData= {
        labels: labels,
        datasets: [
            {
                data: values,
                barThickness: 20,
                borderRadius: 4,
                borderSkipped: false,
                backgroundColor: bgColors,
            }, {
                borderRadius: 4,
                barThickness: 20,
                borderSkipped: false,
                data: bgValues,
                backgroundColor: '#545B66',
            }
        ]
    };

    if (!checkedItems.length) {
        return <></>;
    }

    return <Bar
        data={chartData}
        height='240'
        options={{
            animation: false,
            scales: {
                x: {
                    stacked: true,
                    display: false,
                    beginAtZero: true
                },
                y: {
                    stacked: false,
                    beginAtZero: true,
                    ticks: {
                        maxTicksLimit: 7,
                        color: '#F9F9FA',
                        callback: (value) => {
                            return value.toLocaleString('sv');
                        },
                    },
                }
            },
            plugins: {
                title: {
                    display: false,
                },
                legend: {
                    display: false,
                },
                tooltip: {
                    filter: tooltipItem => tooltipItem.datasetIndex === 0
                },
            }
        }}
    />
}

export default BarChart;